module.exports = __webpack_public_path__ + "static/img/7.1168754.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/sp/7.png
// module id = 5n4C
// module chunks = 0